import { createDragDropManager } from 'dnd-core';
import { HTML5Backend } from 'react-dnd-html5-backend';

/** Shared DragDropManager so multiple DndProviders can coexist without a second HTML5 backend. */
export const dragDropManager = createDragDropManager(HTML5Backend);
